(() => {
  if (customElements.get('dalji-product-pair')) return;
  class DaljiProductPair extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.button = this.querySelector('[data-pair-add]');
      this.error = this.querySelector('[data-pair-error]');
      this.dialog = this.querySelector('dialog');
      this.querySelector('[data-pair-open]')?.addEventListener('click', () => {
        this.updatePrices();
        this.dialog.showModal();
      });
      this.querySelector('[data-pair-close]')?.addEventListener('click', () => this.dialog.close());
      this.dialog?.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      });
      this.button.addEventListener('click', () => this.add());
      this.addEventListener('change', () => this.updatePrices());
      this.variantChanged = event => {
        const select = this.querySelector('[data-pair-variant]');
        const variant = event.detail?.variant;
        if (select && variant && [...select.options].some(option => option.value === String(variant.id))) {
          select.value = String(variant.id);
          this.updatePrices();
        }
      };
      document.addEventListener('variant:changed', this.variantChanged);
      this.updatePrices();
    }
    disconnectedCallback() {
      document.removeEventListener('variant:changed', this.variantChanged);
      this.ready = false;
    }
    updatePrices() {
      let total = 0;
      const cards = [...this.querySelectorAll('.dalji-pair__product')];
      const discount = Boolean(window.DaljiComboPolicy?.allowed(cards.map(card=>window.DaljiComboPolicy.fromCard(card,'[data-pair-variant]'))));
      this.querySelectorAll('[data-pair-variant]').forEach(select => {
        const container = select.closest('.dalji-pair__product') || select.closest('.dalji-inline-pair__variant');
        const output = container?.querySelector('[data-pair-price]');
        const price = Number(select.selectedOptions[0]?.dataset.price || 0);
        const discounted = (discount ? Math.round(price * 93 / 100) : price);
        total += discounted;
        if (output && window.FoxTheme) output.innerHTML = FoxTheme.Currency.formatMoney(price, FoxTheme.settings.moneyFormat);
        if (container && window.FoxTheme) {
          const original = container.querySelector('[data-pair-original]');
          const sale = container.querySelector('[data-pair-discounted]');
          if (original) { original.hidden = !discount; original.innerHTML = FoxTheme.Currency.formatMoney(price, FoxTheme.settings.moneyFormat); }
          if (sale) sale.innerHTML = FoxTheme.Currency.formatMoney(discounted, FoxTheme.settings.moneyFormat);
        }
      });
      if (window.FoxTheme) this.querySelectorAll('[data-pair-total]').forEach(output => {
        output.innerHTML = FoxTheme.Currency.formatMoney(total, FoxTheme.settings.moneyFormat);
      });
      const currentSelect = this.querySelector('[data-pair-variant]');
      const currentSummary = this.querySelector('.dalji-pair-summary__current');
      if (currentSelect && currentSummary && window.FoxTheme) {
        const price = Number(currentSelect.selectedOptions[0]?.dataset.price || 0);
        currentSummary.querySelector('[data-pair-original]').innerHTML = FoxTheme.Currency.formatMoney(price, FoxTheme.settings.moneyFormat);
        currentSummary.querySelector('[data-pair-discounted]').innerHTML = FoxTheme.Currency.formatMoney((discount ? Math.round(price * 93 / 100) : price), FoxTheme.settings.moneyFormat);
      }
    }
    async add() {
      if (this.busy) return;
      const selects = [...this.querySelectorAll('[data-pair-variant]')];
      if (selects.length !== 2 || selects.some(s => s.disabled || !s.value || s.selectedOptions[0]?.disabled)) return;
      this.busy = true;
      this.button.disabled = true;
      this.button.classList.add('btn--loading');
      this.error.hidden = true;
      const root = window.Shopify?.routes?.root || '/';
      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({items: selects.map(s => ({id:s.value,quantity:1}))})
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || 'Não foi possível adicionar as peças. Tente novamente.');
        this.dialog?.close();
        // Discounts remain governed by the existing active Bundler rules.
        if (typeof window.bndlr?.updateCartDiscounts === 'function') window.bndlr.updateCartDiscounts();
        if (document.querySelector('cart-drawer') && window.FoxTheme?.settings.cartType === 'drawer') {
          document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{open:true}}));
        } else window.location.assign(`${root}cart`);
      } catch (error) {
        this.error.textContent = error.message;
        this.error.hidden = false;
      } finally {
        this.busy = false;
        this.button.disabled = false;
        this.button.classList.remove('btn--loading');
      }
    }
  }
  customElements.define('dalji-product-pair',DaljiProductPair);
})();
